import { COMMON_ACTION_BUTTONS } from '../../common';

export const TRANSFER_GROUP_TEMPLATE_ACTION_BUTTONS = [
  {
    ...COMMON_ACTION_BUTTONS.Edit,
    permissionCodes: ['VenuesInventory.TransferGroupTemplate.Manage'],
  },

  {
    ...COMMON_ACTION_BUTTONS.Remove,
    permissionCodes: ['VenuesInventory.TransferGroupTemplate.Delete'],
  },
];
